module.exports = __webpack_public_path__ + "static/media/ro.e9130a28.svg";